import { ManagerOptions, SocketOptions } from 'socket.io-client';

/**
 * Opciones base para conexion Socket.io.
 * - withCredentials envia cookies (JWT refresh_token) al backend
 * - reconnection limitado a 10 intentos con backoff progresivo
 * - transports: websocket primero, polling como fallback
 */
export const SOCKET_OPTIONS: Partial<ManagerOptions & SocketOptions> = {
    autoConnect: true,
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: 10, // limite practico (SocketService aplica reset a los 60s)
    withCredentials: true,
    transports: ['websocket', 'polling'],
    timeout: 20000,
};
